const SCREEN_RULES = [
    ['/truck-detail/', 'trucks.detail'],
    ['/trucks', 'trucks.list'],
    ['/safety/apu-troubleshooting/', 'safety.apu-guide'],
    ['/safety/apu-troubleshooting', 'safety.apu'],
    ['/safety/load-securing', 'safety.load-securing'],
    ['/safety/watch-tracking', 'safety.watch-tracking'],
    ['/safety/driver-scores', 'safety.driver-scores'],
    ['/safety/fleet-dashboard', 'safety.fleet-dashboard'],
    ['/safety/videos', 'safety.videos'],
    ['/safety/equipment', 'safety.equipment'],
    ['/safety/training', 'safety.training'],
    ['/safety/analytics', 'safety.analytics'],
    ['/safety/compliance', 'safety.compliance'],
    ['/safety', 'safety.overview'],
    ['/forms/weekly-checklist', 'forms.weekly-checklist'],
    ['/forms/time-off', 'forms.time-off'],
    ['/forms/apparel', 'forms.apparel'],
    ['/forms-management', 'forms.management'],
    ['/forms', 'forms.overview'],
    ['/feedback/view/', 'feedback.detail'],
    ['/feedback/submit', 'feedback.submit'],
    ['/feedback/roadmap', 'feedback.roadmap'],
    ['/feedback', 'feedback.browse'],
    ['/recruitment', 'recruitment'],
    ['/quotes', 'quotes'],
    ['/customers', 'customers'],
    ['/admin', 'admin'],
    ['/dashboard', 'dashboard'],
    ['/forgot-password', 'auth.forgot-password'],
    ['/reset-password', 'auth.reset-password'],
    ['/temporary-password-reset', 'auth.temporary-reset'],
    ['/logout', 'auth.logout'],
    ['/login', 'auth.login'],
];

function normalizePath(path) {
    const bare = String(path || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
    return bare || '/';
}

export function screenFromPath(path) {
    const p = normalizePath(path);
    if (p === '/') return 'dashboard';
    for (const [prefix, screen] of SCREEN_RULES) {
        if (prefix.endsWith('/')) {
            if (p.startsWith(prefix)) return screen;
            continue;
        }
        if (p === prefix || p.startsWith(`${prefix}/`)) return screen;
    }
    return '';
}

export function viewportClass() {
    const width = window.innerWidth || 0;
    if (width < 600) return 'phone';
    if (width < 1200) return 'tablet';
    return 'desktop';
}

export function usageSessionId() {
    const key = 'usageSession';
    try {
        let id = sessionStorage.getItem(key) || '';
        if (!/^[A-Za-z0-9-]{8,40}$/.test(id)) {
            id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`).slice(0, 40);
            sessionStorage.setItem(key, id);
        }
        return id;
    } catch {
        return '';
    }
}

export function readMarkedScreen() {
    const dialogs = document.querySelectorAll('[role="dialog"] [data-usage-screen]');
    for (let i = dialogs.length - 1; i >= 0; i -= 1) {
        const value = dialogs[i].getAttribute('data-usage-screen');
        if (value) return value;
    }
    const nodes = document.querySelectorAll('[data-usage-screen]');
    for (let i = nodes.length - 1; i >= 0; i -= 1) {
        const node = nodes[i];
        if (node.closest('[hidden]')) continue;
        const value = node.getAttribute('data-usage-screen');
        if (value) return value;
    }
    return '';
}

export function currentScreen(path) {
    return readMarkedScreen() || screenFromPath(path);
}
